import { render, staticRenderFns } from "./OfficesTimeFloatBtns.vue?vue&type=template&id=15f5aeba&"
import script from "./OfficesTimeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./OfficesTimeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports